import React, { useState, useEffect } from "react";
import ParagraphTag from "../reusebale/Paragraph";
import ImageTag from "../reusebale/imageTag";
import ReactPaginate from "react-paginate";
import NoData from "../reusebale/noData";
import LeaseTableLoader from "../skeleton-loader/lease-table";
import MyLoader from "../reusebale/MyLoader";
import moment from "moment";
import {
  ArrowUpDown,
  ArrowDownUp,
  SquareX,
  SquareCheck,
  ArrowRight,
} from "lucide-react";
import db from "../../db/index.json";
import BaseUrl from "../../constants/BaseUrl";
import { useSelector } from "react-redux";
import { ShowError, ShowSuccess } from "../../utils/ToasFunction";

const Contactuslist = ({ onViewDetails }) => {
  const { landlord, rightPanel } = db;

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;
  const [AllLandlord, setAllLandlord] = useState([]);

  const { loginSuccess } = useSelector((state) => state.auth);
  const [selectedId, setSelectedId] = useState();
  const [loader, setLoader] = useState(false);

  const GetAllContactUs = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/contact/getAllContactQueries?page=${currentPage}&limit=${itemsPerPage}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setAllLandlord(result.data || []);
          setTotalPages(result.totalPages || 1);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    GetAllContactUs();
  }, [currentPage]);

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const [sortConfig, setSortConfig] = useState({
    key: "lease",
    direction: "asc",
  });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...AllLandlord].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setAllLandlord(sortedData);
  };

  const ChangeStatusToComplete = (id) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      id: id,
      status: "completed",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/contact/updateQueryStatus`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          GetAllContactUs();
          setLoader(false);
          setSelectedId();
          ShowSuccess("Action updated successfully.");
        } else {
          setLoader(false);
          ShowError("Oops! Something went wrong.");
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <div className="h-full pt-5">
      <div className="bg-white w-full h-[87%]">
        <div className="w-[95%] mx-auto h-full">
          <div className="flex items-center h-[12%]">
            <ParagraphTag
              content={"Contact Us"}
              classes="text-darkColor font-popinsSemiBold text-base pl-2"
            />
          </div>
          <div className="overflow-x-scroll w-full h-[88%] panelScroll pt-2">
            <table className="w-full ">
              <thead className="sticky top-0 bg-white">
                <tr className="border-b border-black/20">
                  <th className="w-[20%] text-left pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={"Name"}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                    </span>
                  </th>
                  <th className="w-[20%] pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={"Organisation"}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                    </span>
                  </th>
                  <th className="w-[10%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={"Email"}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                    </span>
                  </th>
                  <th className="w-[13%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={"Number"}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                    </span>
                  </th>
                  <th className="w-[27%] pb-2">
                    <span className="flex justify-center w-full">
                      <ParagraphTag
                        content={"Description"}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                    </span>
                  </th>

                  <th className="w-[10%] text-right pr-4 pb-2">
                    <ParagraphTag
                      content={"Action"}
                      classes="text-darkColor/40 font-popinsSemiBold text-xs"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {AllLandlord.map((item, i) => (
                  <tr
                    key={i}
                    className="hover:bg-gray-100 rounded-md cursor-pointer"
                  >
                    <td className="py-2">
                      <div className="flex items-center justify-between">
                        <div className=" rounded-full">
                          <ParagraphTag
                            content={`${item?.name}`}
                            classes="text-darkColor/50 font-popinsMedium text-xs"
                          />
                          <span className="font-popinsMedium text-sm">
                            {moment(item?.createdAt).format("MM/DD/YYYY")}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="py-2">
                      <div className="flex items-center justify-between">
                        <div className="w-[75%] cursor-pointer">
                          <ParagraphTag
                            content={`${item?.organisation}`}
                            classes="text-darkColor font-popinsMedium text-sm"
                          />
                        </div>
                      </div>
                    </td>
                    <td className="py-2 font-popinsMedium text-darkColor text-sm">
                      <ParagraphTag
                        content={`${item?.email}`}
                        classes="text-darkColor font-popinsMedium text-sm"
                      />
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      <ParagraphTag
                        content={`${item?.phone}`}
                        classes="text-darkColor font-popinsMedium text-sm"
                      />
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center group relative">
                      <span className="line-clamp-1">{item?.description}</span>

                      {/* Dialog box with full text on hover */}
                      <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 p-4 bg-gray-800 text-gray-50 rounded shadow-md z-50 max-w-none w-52  overflow-auto hidden group-hover:block whitespace-normal">
                        {item?.description}
                      </div>
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-xs text-center">
                      <div className="flex justify-center">
                        {item._id === selectedId && loader ? (
                          <div className="flex justify-center items-center h-2">
                            <MyLoader />
                          </div>
                        ) : (
                          <label class="inline-flex items-center cursor-pointer relative pl-3">
                            <input
                              checked={item.status === "completed"}
                              value={item.id}
                              type="checkbox"
                              className="sr-only peer"
                              onChange={(e) => {
                                setSelectedId(item._id);
                                ChangeStatusToComplete(item._id);
                              }}
                            />
                            <div class="relative w-11 h-6 bg-[#E43B3B38] peer-focus:outline-none rounded-full peer dark:bg-[#E43B3B38] peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-[#0381CA] after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-[#0381CA] after:border-[#0381CA] after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-[#0381CA] peer-checked:bg-[#E43B3B38]"></div>
                          </label>
                        )}
                      </div>
                    </td>
                    <td className="pt-5 2xl:pt-4 px-4 flex justify-center items-center h-full">
                      {/* <div
                        onClick={() => {
                          onViewDetails(item);
                        }}
                        className="flex justify-center items-center border border-themeColor w-7 h-7 rounded-md cursor-pointer"
                      >
                        <ArrowRight color="#6F6F6F" size={18} strokeWidth={2} />
                      </div> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {loading && <LeaseTableLoader />}
            {!loading && AllLandlord.length === 0 && (
              <div className="w-full mt-5">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center h-[13%]">
        <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          breakLabel="..."
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName="flex space-x-2 items-center"
          pageClassName="px-3 py-1 border rounded-md text-sm font-popinsMedium cursor-pointer"
          previousClassName="px-3 py-1 border rounded-l-md text-sm cursor-pointer font-popinsMedium"
          nextClassName="px-3 py-1 border rounded-r-md text-sm font-popinsMedium cursor-pointer"
          disabledClassName="opacity-50 !cursor-not-allowed"
          activeClassName="bg-themeColor text-white"
          breakClassName="px-3 py-1 text-sm font-popinsMedium"
        />
      </div>
    </div>
  );
};

export default Contactuslist;
